import styled from "styled-components";

import {ContactStep} from "./contact";
import {useDelayedFadeIn} from "utils/animation-delay";
import {FadeIn} from "components/fade-in";

type Props = {
    setContactStep: (contactStep: ContactStep) => void;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const Content = styled.div`
  margin-top: 120px;
  max-width: 320px;
`;

export const Title = styled.h1`
  font-weight: bold;
  text-align: center;
`

export const ContactSuccess = ({setContactStep}: Props) => {
    const {nextDelay} = useDelayedFadeIn({});

    return <Container>
        <Content>
            <Title>
                <FadeIn nextDelay={nextDelay}>
                    Thank you!
                </FadeIn>
            </Title>
            <h5 className="mt-5">
                <FadeIn nextDelay={nextDelay}>
                    Please allow us approximately 24 hours to get back to you!
                </FadeIn>
            </h5>
        </Content>
    </Container>;
}
